import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, styled, Toolbar } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSuperadminAuth } from '../contexts/SuperadminAuthContext';
import { AppHeader, AppSidebar } from '@/components/layout';
import { superadminMenuItems } from '../config/menuConfig';
import { SUPERADMIN_ROUTES } from '../routes/routes';

const drawerWidth = 240;
const collapsedWidth = 64;

// Styled components
const MainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  backgroundColor: '#ebedf7',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(3),
}));

const SuperadminMainLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useSuperadminAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate(SUPERADMIN_ROUTES.LOGIN);
    } catch (error) {
      console.error('Logout failed:', error);
      // Force navigation even if logout fails
      navigate(SUPERADMIN_ROUTES.LOGIN);
    }
  };

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppHeader
        title="WaterPe Superadmin"
        user={
          user
            ? {
                name: user.name,
                email: user.email,
                avatar: user.avatar,
              }
            : undefined
        }
        onLogout={handleLogout}
        drawerWidth={drawerWidth}
        collapsed={sidebarCollapsed}
        onToggleSidebar={toggleSidebar}
      />

      <AppSidebar
        width={drawerWidth}
        collapsedWidth={collapsedWidth}
        collapsed={sidebarCollapsed}
        logo={{
          src: '/logos/logo-white_1.png',
          alt: 'GrowthBnk Logo',
          height: 40,
        }}
        menuItems={superadminMenuItems}
        currentPath={location.pathname}
        onNavigate={path => navigate(path)}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          px: 4,
          overflowX: 'hidden',
          py: 4,
          minHeight: '100vh',
          transition: theme =>
            theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
        }}
      >
        <Toolbar />
        <MainContainer>
          <Outlet />
        </MainContainer>
      </Box>
    </Box>
  );
};

export default SuperadminMainLayout;

